import { render, staticRenderFns } from "./Page500.vue?vue&type=template&id=1f93e71a&"
import script from "./Page500.vue?vue&type=script&lang=js&"
export * from "./Page500.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports